import { render, staticRenderFns } from "./tealoading.vue?vue&type=template&id=588e21b0&scoped=true&"
import script from "./tealoading.vue?vue&type=script&lang=js&"
export * from "./tealoading.vue?vue&type=script&lang=js&"
import style0 from "./tealoading.vue?vue&type=style&index=0&id=588e21b0&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588e21b0",
  null
  
)

export default component.exports